export const convertDate = dateString => {
  const dateObject = new Date(dateString);
  const month = dateObject.getUTCMonth();
  const date = dateObject.getUTCDate();
  const year = dateObject.getUTCFullYear();
  return `${month + 1}/${date}/${year}`;
};

export const centsToDollars = cents => {
  if (typeof cents === 'number' && cents !== 0) {
    return (cents / 100).toLocaleString('en-US', {
      style: 'currency',
      currency: 'USD',
    });
  }
  return '';
};

export const centsToCurrency = (
  cents: number,
  currency = 'USD',
  showCurrency = false
) =>
  `${((cents || 0) / 100).toLocaleString('en-US', {
    style: 'currency',
    currency,
  })}${showCurrency && currency !== 'USD' ? ` ${currency}` : ''}`.replace(
    /^([a-zA-Z]+)/,
    ''
  );

export const hexToRgb = hex => {
  // Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")
  const shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
  const modifiedHex = hex.replace(
    shorthandRegex,
    (_m, r, g, b) => r + r + g + g + b + b
  );
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(modifiedHex);
  return result
    ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16),
      }
    : null;
};
